import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  container: {
    padding: 10,
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  headerTitle: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  row: {
    width: '98%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    margin: '0px 5px',
    padding: '3px',
  },
  rowHeader: {
    width: '98%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    margin: '0px 5px',
    padding: '3px',
    backgroundColor: '#5BAFF5',
    color: '#fff',
  },
  columnHeader: {
    flex: 1,
    fontSize: 8,
    fontWeight: 700,
  },
  column: {
    flex: 1,
    fontSize: 8,
  },
});
